module.exports = __webpack_public_path__ + "8397e867d0aa93cfd1f0636c3e7616ee.pdf";